import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ORIGIN = '0% 100%';

const bindSection = (section) => {
	const motion = section.querySelector('.js-problem-decoration');
	const path = section.querySelector('.js-problem-decoration-path');
	const anchor = motion?.closest('.section__decoration');

	if (!motion || !path || !anchor) {
		return null;
	}

	gsap.set(motion, { transformOrigin: ORIGIN });
	gsap.set(path, { transformOrigin: ORIGIN, opacity: 0.1 });

	let idleTween = null;
	let glowTween = null;

	const entrance = gsap.timeline({
		scrollTrigger: {
			trigger: section,
			start: 'top 80%',
			once: true,
		},
		defaults: { ease: 'power3.out' },
		onComplete: () => {
			idleTween = gsap.to(motion, {
				y: -7,
				duration: 2.6,
				ease: 'sine.inOut',
				yoyo: true,
				repeat: -1,
			});

			glowTween = gsap.to(path, {
				opacity: 0.17,
				duration: 2.6,
				ease: 'sine.inOut',
				yoyo: true,
				repeat: -1,
			});
		},
	});

	entrance
		.fromTo(
			motion,
			{ y: 36, rotation: -12, autoAlpha: 0 },
			{ y: 0, rotation: 0, autoAlpha: 1, duration: 1.15 },
		)
		.fromTo(
			path,
			{ scale: 0.55, opacity: 0 },
			{ scale: 1, opacity: 0.1, duration: 0.9, ease: 'back.out(1.6)' },
			'-=0.75',
		);

	const parallax = gsap.fromTo(
		anchor,
		{ y: 12 },
		{
			y: -22,
			ease: 'none',
			scrollTrigger: {
				trigger: section,
				start: 'top bottom',
				end: 'bottom top',
				scrub: 0.85,
			},
		},
	);

	return () => {
		entrance.scrollTrigger?.kill();
		parallax.scrollTrigger?.kill();
		idleTween?.kill();
		glowTween?.kill();
		gsap.killTweensOf([motion, path, anchor]);
		gsap.set([motion, path, anchor], { clearProps: 'all' });
		path.style.opacity = '0.1';
	};
};

export const initProblemDecoration = () => {
	const sections = document.querySelectorAll('.section--problem');
	if (!sections.length) {
		return;
	}

	const cleanups = [];

	gsap.matchMedia().add('(prefers-reduced-motion: no-preference) and (min-width: 1100px)', () => {
		sections.forEach((section) => {
			const cleanup = bindSection(section);
			if (cleanup) {
				cleanups.push(cleanup);
			}
		});

		return () => {
			cleanups.forEach((fn) => fn());
		};
	});
};
